import React from 'react';
import PropTypes from 'prop-types';
import { Table as AntTable } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import AppModal from '@/pages/inside/tenant/AppModal';
import {
    CreateRolePermSection,
    StickyPermHeader,
    ProfilePermSearchWrapper,
    ProfilePermSearchInput,
    ThemedAntTableWrap,
} from '@/pages/inside/tenant/style';

const ProfilePermissionsModal = ({
    open,
    onClose,
    permSearch,
    onPermSearchChange,
    permissionTableRows,
}) => (
    <AppModal size="md" title="Your permissions" open={open} onCancel={onClose} footer={null}>
        <CreateRolePermSection>
            <StickyPermHeader>
                <ProfilePermSearchWrapper>
                    <SearchOutlined />
                    <ProfilePermSearchInput
                        placeholder="Search permissions by module, feature, or action"
                        value={permSearch}
                        onChange={(e) => onPermSearchChange(e.target.value)}
                    />
                </ProfilePermSearchWrapper>
            </StickyPermHeader>
            <ThemedAntTableWrap>
                <AntTable
                    size="small"
                    pagination={false}
                    dataSource={permissionTableRows}
                    locale={{ emptyText: permSearch.trim() ? 'No permissions match your search.' : 'No permissions.' }}
                    columns={[
                        { title: 'Module', dataIndex: 'module', key: 'module', width: 140 },
                        { title: 'Feature', dataIndex: 'feature', key: 'feature', width: 160 },
                        { title: 'Action', dataIndex: 'action', key: 'action' },
                    ]}
                />
            </ThemedAntTableWrap>
        </CreateRolePermSection>
    </AppModal>
);

ProfilePermissionsModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    permSearch: PropTypes.string.isRequired,
    onPermSearchChange: PropTypes.func.isRequired,
    permissionTableRows: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ProfilePermissionsModal;
